import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Text from "../../main/Text";
import BackButton from "../../main/BackButton";

const TwoBoutiques = (props) => {
    const location = useLocation();
    const { type } = location.state || {};
    const [content, setContent] = useState('');

    useEffect(() => {
        if (type === 'digital') {
            setContent('this website is our digital boutique.')
        } else {
            setContent('currently we have no physical boutique.')
        }
    }, [type])

    return (
        <>
            <BackButton />
            <Text>
                {content}
            </Text>
        </>
    )
}

export default TwoBoutiques;
